import type { MeetingStatus } from "./models";

/** Meeting statuses that should be excluded from "upcoming" lists */
export const INACTIVE_MEETING_STATUSES: MeetingStatus[] = ["completed", "cancelled", "skipped", "removed"];
